import { render } from "./AlternativeAddress.vue?vue&type=template&id=610e9bbf"
import script from "./AlternativeAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./AlternativeAddress.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/start/AlternativeAddress.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "610e9bbf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('610e9bbf', __exports__)) {
    api.reload('610e9bbf', __exports__)
  }
  
  module.hot.accept("./AlternativeAddress.vue?vue&type=template&id=610e9bbf", () => {
    api.rerender('610e9bbf', render)
  })

}


export default __exports__